<template>
  <div class="statistic-container">
    <div class="statistic">
      <h1>Эпидемиологическая<br>ситуация по коронавирусу</h1>
      <div v-if="statistic.world">
        <div class="statistic-tabnames">
          <span
            class="statistic-tabname"
            :class="{active: statisticActive == 'russia'}"
            @click="changeStatistic('russia')">В России</span>
          <span
            class="statistic-tabname" 
            :class="{active: statisticActive == 'world'}"
            @click="changeStatistic('world')">В мире</span>
        </div>
        <div class="statistic-tab" v-if="statisticActive == 'russia'">
          <span class="statistic-current">Актуально на {{statistic.russia.lastUpdate | moment("timezone", "Europe/Moscow", "D MMMM YYYY HH:mm")}} (МСК) *</span>
          <span class="statistic-current__note">* Статистика обновляется раз в сутки и показывает прирост за 24 часа</span>
          <div class="statistic-block">
            <span class="statistic-block__name">Заражений:</span>
            <div class="statistic-block-numbers">
              <span>{{statistic.russia.caseTotal | numberDigits}}</span>
              <span class="statistic-block-numbers__new total">+{{statistic.russia.caseNew | numberDigits}}</span>
            </div>
          </div>
          <div class="statistic-block">
            <span class="statistic-block__name">Выздоровлений:</span>
            <div class="statistic-block-numbers">
              <span>{{statistic.russia.recoveredTotal | numberDigits}}</span>
              <span class="statistic-block-numbers__new recovered">+{{statistic.russia.recoveredNew | numberDigits}}</span>
            </div>
          </div>
          <div class="statistic-block">
            <span class="statistic-block__name">Скончалось:</span>
            <div class="statistic-block-numbers">
              <span>{{statistic.russia.deathsTotal | numberDigits}}</span>
              <span class="statistic-block-numbers__new death">+{{statistic.russia.deathsNew | numberDigits}}</span>
            </div>
          </div>
        </div>
        <div class="statistic-tab" v-else>
          <span class="statistic-current">Актуально на {{statistic.world.lastUpdate | moment("timezone", "Europe/Moscow", "D MMMM YYYY HH:mm")}} (МСК) *</span>
          <span class="statistic-current__note">* Статистика обновляется в режиме реального времени и показывает прирост за {{statistic.world.lastUpdate | moment("timezone", "Europe/Moscow", "DD.MM.YYYY")}}</span>
          <div class="statistic-block">
            <span class="statistic-block__name">Заражений:</span>
            <div class="statistic-block-numbers">
              <span>{{statistic.world.caseTotal | numberDigits}}</span>
              <span class="statistic-block-numbers__new total">+{{statistic.world.caseNew | numberDigits}}</span>
            </div>
          </div>
          <div class="statistic-block">
            <span class="statistic-block__name">Выздоровлений:</span>
            <div class="statistic-block-numbers">
              <span>{{statistic.world.recoveredTotal | numberDigits}}</span>
              <span class="statistic-block-numbers__new recovered">+{{statistic.world.recoveredNew | numberDigits}}</span>
            </div>
          </div>
          <div class="statistic-block">
            <span class="statistic-block__name">Скончалось:</span>
            <div class="statistic-block-numbers">
              <span>{{statistic.world.deathsTotal | numberDigits}}</span>
              <span class="statistic-block-numbers__new death">+{{statistic.world.deathsNew | numberDigits}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  async created() {
    await this.$store.dispatch('getStatistic');
  },
  data() {
    return {
      statisticActive: 'russia'
    }
  },
  computed: {
    statistic() {
      return this.$store.state.statistic;
    }
  },
  methods: {
    changeStatistic(type) {
      this.statisticActive = type;
    }
  }
}
</script>

<style lang="scss" scoped>
.statistic {
  padding: 60px 0;
  max-width: 620px;
  margin: 0 auto;
  &-container {
    background-color: #f2f7f9;
  }
  &-current {
    background: #000;
    padding: 0 10px;
    height: 44px;
    border-radius: 5px;
    background-color: #0096c8;
    font-size: 15px;
    color: #fff;
    font-size: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-bottom: 10px;
    &__note {
      display: block;
      margin-bottom: 10px;
      font-size: 13px;
    }
  }
  &-tabnames {
    display: flex;
    justify-content: space-between;
  }
  &-tabname {
    width: 48%;
    height: 60px;
    box-shadow: 0 3px 6px rgba(194, 213, 225, 0.99);
    border-radius: 5px;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #000;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
    background: #fff;
    &.active {
      box-shadow: none;
      background-color: #e2ebf0;
    }
  }
  &-tab {
    text-align: center;
  }
  &-block {
    &:last-child .statistic-block-numbers {
      margin-bottom: 0;
    }
    &__name {
      display: block;
      margin-bottom: 15px;
      text-align: center;
      font-size: 20px;
    }
    &-numbers {
      border-radius: 5px;
      border: 4px solid #f2f7f9;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 52px;
      font-weight: bold;
      height: 102px;
      margin-bottom: 20px;
      background: #fff;
      &__new {
        margin-left: 20px;
        &.total {
          color: #98b6c8;
        }
        &.recovered {
          color: #64d282;
        }
        &.death {
          color: #f66d6d;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .statistic {
    padding: 40px 20px;
    &-current {
      margin-bottom: 28px;
    }
    &-tabname {
      font-size: 15px;
      height: 40px;
      margin-bottom: 33px;
    }
    &-block {
      &__name {
        font-size: 15px;
      }
      &-numbers {
        height: 49px;
        font-size: 24px;
        margin-bottom: 25px;
        &__new {
          margin-left: 9px;
        }
      }
    }
  }
}
</style>